import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { AvaliacaoAction } from "./Avaliacao.action"
import { AvaliacaoActionTypes, AvaliacaoFormularioState } from "./Avaliacao.types"


const estadoInicial: AvaliacaoFormularioState = {
  estado: EstadoRequisicao.OCIOSO,
  erros: undefined,
}


export const avaliacaoFormularioReducer: Reducer<AvaliacaoFormularioState, AvaliacaoActionTypes> = (state = estadoInicial, action): AvaliacaoFormularioState => {
  if (AvaliacaoAction.formulario.iniciar.match(action)) {
    return {
      estado: EstadoRequisicao.OCIOSO,
      erros: undefined,
    }

  } else if (AvaliacaoAction.formulario._enviar.pending.match(action)) {
    return {
      estado: EstadoRequisicao.CARREGANDO,
      erros: undefined,
    }

  } else if (AvaliacaoAction.formulario._enviar.fulfilled.match(action)) {
    return {
      estado: EstadoRequisicao.BEM_SUCEDIDO,
      erros: undefined
    }

  } else if (AvaliacaoAction.formulario._enviar.rejected.match(action)) {
    return {
      estado: EstadoRequisicao.FALHOU,
      erros: action.payload as ResponseError,
    }
  }

  return state;
}
